import { AssetFluid } from './asset'
import { ExternalLink, InternalLink } from './page'

type Enumerate<
  N extends number,
  Acc extends number[] = []
> = Acc['length'] extends N
  ? Acc[number]
  : Enumerate<N, [...Acc, Acc['length']]>

export type IntRange<F extends number, T extends number> = Exclude<
  Enumerate<T>,
  Enumerate<F>
>
export type ColumnRange = IntRange<1, 13>

interface GridCell {
  title: string
  cellIcon: AssetFluid
  link: ExternalLink | InternalLink
}

export interface IGenericGrid {
  gridCells: GridCell[]
  mobile: ColumnRange
  tablet: ColumnRange
  laptop: ColumnRange
  desktop: ColumnRange
  spacing?: 0 | Exclude<ColumnRange, IntRange<11, 13>>
}

export interface IGenericGridReference {
  gridCells: GridCell[]
  mobileColumns: ColumnRange
  tabletColumns: ColumnRange
  laptopColumns: ColumnRange
  desktopColumns: ColumnRange
  spaceBetweenCells?: 0 | Exclude<ColumnRange, IntRange<11, 13>>
}

export function getOverridenBreakpointKeysObject({
  xs,
  xl,
  sm,
  lg,
  md,
  ...rest
}: any) {
  return rest
}

/**
 * Converts numbers to two decimal places without rounding errors
 * Number.EPSILON is used for weird rounding errors
 */
export function toTwoDecimalPlaces(value: number): number {
  return Math.round((value + Number.EPSILON) * 100) / 100
}
